<template>
  <div
    :class="[
      'mobile-navbar offcanvas offcanvas-end border-0',
      { show: stateStoreInstance.navbar },
    ]"
  >
    <div class="offcanvas-header">
      <RouterLink to="/" class="logo d-inline-block">
        <img src="@/assets/images/logo.svg" alt="الشعار" />
      </RouterLink>
      <RouterLink to="/" class="logo d-none">
        <img src="@/assets/images/white-logo.svg" alt="الشعار" />
      </RouterLink>

      <button
        type="button"
        class="close-btn bg-transparent position-relative lh-1 p-0 border-0"
        @click="stateStoreInstance.responsiveNavbar"
      >
        <i class="ri-close-fill"></i>
      </button>
    </div>

    <div class="offcanvas-body">
      <ul class="mobile-menu">
        <li :class="['mobile-menu-list', { active: isActive('home') }]">
          <a class="menu-link menu-toggle active" @click="toggleMenu('home')">
            الرئيسية
          </a>

          <ul class="mobile-menu-items" v-show="isActive('home')">
            <li>
              <RouterLink
                class="dropdown-item"
                to="/"
                @click="stateStoreInstance.responsiveNavbar"
              >
                مزود خدمة الإنترنت (ISP)
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/iptv-service"
                @click="stateStoreInstance.responsiveNavbar"
              >
                خدمة IPTV
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/isp-broadband"
                @click="stateStoreInstance.responsiveNavbar"
              >
                إنترنت النطاق العريض (Broadband)
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/ott-platform"
                @click="stateStoreInstance.responsiveNavbar"
              >
                منصة OTT
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/movie-home"
                @click="stateStoreInstance.responsiveNavbar"
              >
                رئيسية الأفلام
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/satellite-internet"
                @click="stateStoreInstance.responsiveNavbar"
              >
                الإنترنت الفضائي
              </RouterLink>
            </li>
          </ul>
        </li>

        <li :class="['mobile-menu-list', { active: isActive('services') }]">
          <a
            class="menu-link menu-toggle active"
            @click="toggleMenu('services')"
          >
            الخدمات
          </a>

          <ul class="mobile-menu-items" v-show="isActive('services')">
            <li>
              <RouterLink
                class="dropdown-item"
                to="/services"
                @click="stateStoreInstance.responsiveNavbar"
              >
                الخدمات
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/services-details"
                @click="stateStoreInstance.responsiveNavbar"
              >
                تفاصيل الخدمات
              </RouterLink>
            </li>
          </ul>
        </li>

        <li :class="['mobile-menu-list', { active: isActive('pages') }]">
          <a class="menu-link menu-toggle active" @click="toggleMenu('pages')">
            الصفحات
          </a>

          <ul class="mobile-menu-items" v-show="isActive('pages')">
            <li>
              <RouterLink
                class="dropdown-item"
                to="/about-us"
                @click="stateStoreInstance.responsiveNavbar"
              >
                من نحن
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/testimonials"
                @click="stateStoreInstance.responsiveNavbar"
              >
                آراء العملاء
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/pricing-plan"
                @click="stateStoreInstance.responsiveNavbar"
              >
                خطة الأسعار
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/channel-list"
                @click="stateStoreInstance.responsiveNavbar"
              >
                قائمة القنوات
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/faq"
                @click="stateStoreInstance.responsiveNavbar"
              >
                الأسئلة الشائعة
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/privacy-policy"
                @click="stateStoreInstance.responsiveNavbar"
              >
                سياسة الخصوصية
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/terms-conditions"
                @click="stateStoreInstance.responsiveNavbar"
              >
                الشروط والأحكام
              </RouterLink>
            </li>
          </ul>
        </li>

        <li :class="['mobile-menu-list', { active: isActive('shop') }]">
          <a class="menu-link menu-toggle active" @click="toggleMenu('shop')">
            المتجر
          </a>

          <ul class="mobile-menu-items" v-show="isActive('shop')">
            <li>
              <RouterLink
                class="dropdown-item"
                to="/products"
                @click="stateStoreInstance.responsiveNavbar"
              >
                المنتجات
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/product-details"
                @click="stateStoreInstance.responsiveNavbar"
              >
                تفاصيل المنتج
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/cart"
                @click="stateStoreInstance.responsiveNavbar"
              >
                سلة المشتريات
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/checkout"
                @click="stateStoreInstance.responsiveNavbar"
              >
                إتمام الطلب
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/pay-bill"
                @click="stateStoreInstance.responsiveNavbar"
              >
                دفع الفاتورة
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/pay-bill-pin"
                @click="stateStoreInstance.responsiveNavbar"
              >
                رمز دفع الفاتورة (PIN)
              </RouterLink>
            </li>
          </ul>
        </li>

        <li :class="['mobile-menu-list', { active: isActive('blog') }]">
          <a class="menu-link menu-toggle active" @click="toggleMenu('blog')">
            المدونة
          </a>

          <ul class="mobile-menu-items" v-show="isActive('blog')">
            <li>
              <RouterLink
                class="dropdown-item"
                to="/blog"
                @click="stateStoreInstance.responsiveNavbar"
              >
                المدونة
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/blog-details"
                @click="stateStoreInstance.responsiveNavbar"
              >
                تفاصيل المقال
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/tags"
                @click="stateStoreInstance.responsiveNavbar"
              >
                الأوسام (Tags)
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/categories"
                @click="stateStoreInstance.responsiveNavbar"
              >
                التصنيفات
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/author"
                @click="stateStoreInstance.responsiveNavbar"
              >
                الكاتب
              </RouterLink>
            </li>
          </ul>
        </li>

        <li
          :class="['mobile-menu-list', { active: isActive('authentication') }]"
        >
          <a
            class="menu-link menu-toggle active"
            @click="toggleMenu('authentication')"
          >
            تسجيل الدخول والتوثيق
          </a>

          <ul class="mobile-menu-items" v-show="isActive('authentication')">
            <li>
              <RouterLink
                class="dropdown-item"
                to="/login-register"
                @click="stateStoreInstance.responsiveNavbar"
              >
                تسجيل الدخول / التسجيل
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/login"
                @click="stateStoreInstance.responsiveNavbar"
              >
                تسجيل الدخول
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/register"
                @click="stateStoreInstance.responsiveNavbar"
              >
                حساب جديد
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/change-password"
                @click="stateStoreInstance.responsiveNavbar"
              >
                تغيير كلمة المرور
              </RouterLink>
            </li>
            <li>
              <RouterLink
                class="dropdown-item"
                to="/forgot-password"
                @click="stateStoreInstance.responsiveNavbar"
              >
                نسيت كلمة المرور
              </RouterLink>
            </li>
          </ul>
        </li>

        <li class="mobile-menu-list without-icon">
          <RouterLink
            to="/pricing-plan"
            class="nav-link"
            @click="stateStoreInstance.responsiveNavbar"
          >
            خطة الأسعار
          </RouterLink>
        </li>

        <li class="mobile-menu-list without-icon">
          <RouterLink
            to="/contact-us"
            class="nav-link"
            @click="stateStoreInstance.responsiveNavbar"
          >
            اتصل بنا
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import stateStore from "@/utils/store";

export default defineComponent({
  name: "MobileNavbar",
  setup() {
    const stateStoreInstance = stateStore;

    const openMenu = ref<string | null>(null);

    const toggleMenu = (menu: string | null) => {
      openMenu.value = openMenu.value === menu ? null : menu;
    };

    const isActive = (menu: string | null) => {
      return openMenu.value === menu;
    };

    return {
      stateStoreInstance,
      toggleMenu,
      isActive,
    };
  },
});
</script>